// First and last item numbers shown for a page ("start-end of total").
export const getItemRange = (
  currentPage: number,
  itemsPerPage: number,
  totalCount: number,
) => {
  if (totalCount === 0) return { startItemNumber: 0, endItemNumber: 0 };
  return {
    startItemNumber: (currentPage - 1) * itemsPerPage + 1,
    endItemNumber: Math.min(currentPage * itemsPerPage, totalCount),
  };
};
